import IconCollapsible from 'assets/img/icons/collapsible.svg';
import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import 'components/company/revamp/parts/setting/customWla/list/index.scss';
import Table from 'components/company/revamp/parts/setting/customWla/list/table';
import { useState } from 'react';
import styled from 'styled-components';
import dataStatus from './dataStatus';

const ButtonMod = styled(Button)`
  width: 100%;
  height: 24px;
  float: right;
`;

const WrapBtnAdd = styled.div`
  width: 200px;
  grid-column-start: 2;
`;
function Collapsible(props) {
  const {
    t, activeCollapsible, setActiveCollapsible, activity_type_list_: activityClassification,
  } = props;

  const handleCollapse = (category) => {
    if (activeCollapsible === category) {
      setActiveCollapsible(null);
      props?.setCategory(null);
    } else {
      setActiveCollapsible(category);
      props?.setCategory(`category_${category.toLowerCase()}`);
    }
  };

  const sortingActivity = activityClassification
    .sort((a, b) => a.order - b.order)
    .map((parent) => ({
      ...parent,
      detail_category: [...parent.detail_category].sort((a, b) => a.order - b.order),
    }));

  return (
    <div className="custom_wla-collapsible-container">
      {sortingActivity?.map((value) => (
        <div
          key={value.wla_category_id}
          className="custom_wla-collapsible-content"
        >
          <div className="custom_wla-collapsible-content-left">
            <Label typeLabel="label_option">{value.title}</Label>
          </div>
          <div className="custom_wla-collapsible-content-right">
            <div className="custom_wla-collapsible-content-right-status">
              {dataStatus({ data: value.status, t })}
            </div>
            <div className="btn-edit">
              <Button
                icon="edit"
                style={{ height: '100%' }}
                func={() => {
                  props.setShowModal(!props?.showModal);
                  props?.setTypeForm('edit');
                  // props?.setId(i);
                  props?.setSelectedData(value);
                }}
              />
            </div>
            <div
              className="btn-collapsible"
              onClick={() => handleCollapse(value.wla_category_id)}
            >
              <img
                alt="edit"
                src={IconCollapsible}
                style={{
                  transform:
                    activeCollapsible === value.wla_category_id
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                }}
              />
            </div>
          </div>
          {activeCollapsible === value.wla_category_id && (
            <>
              <Table {...props} data={value.detail_category} />
              <WrapBtnAdd>
                <ButtonMod
                  icon="create"
                  style={{ margin: '6px 0px 0px 0px' }}
                  func={() => {
                    props?.setShowModal(!props?.showModal);
                    props?.setTypeForm('create-sub');
                    props?.setSelectedData(value);
                  }}
                >
                  &nbsp;&nbsp;
                  {t('company.add_sub_category')}
                </ButtonMod>
              </WrapBtnAdd>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default Collapsible;
